import { Injectable, OnInit, NgZone, OnDestroy } from '@angular/core';
import { BehaviorSubject, interval, of, Subject, Subscription } from 'rxjs';
import { operationinterface } from '../interface/OperationInterface';
import { HttpClient } from '@angular/common/http';
import { SseService } from './SseService';
import { global } from '../global';
import { CookieService } from 'ngx-cookie-service';
import { switchMap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ColaOrdenesService implements OnDestroy {
  private colaOrdenesSource = new BehaviorSubject<any[]>([]);
  private colaOrdenesSourceGestor = new BehaviorSubject<any[]>([]);
  private operacionesSource = new BehaviorSubject<operationinterface[]>([]);
  private operacionesSourceGestor = new BehaviorSubject<operationinterface[]>([]);
  private idcartera: number = 0;
  private idcarteragestor: number = 0;
  colaOrdenes$ = this.colaOrdenesSource.asObservable();
  colaOrdenesGestor$ = this.colaOrdenesSourceGestor.asObservable();
  operaciones$ = this.operacionesSource.asObservable();
  operacionesGestor$ = this.operacionesSourceGestor.asObservable();
  /** Pedidos de cancelación (por cOID) de órdenes en cola; los atiende el dueño de la cola (BrokerComponent). */
  private cancelarSource = new Subject<string>();
  cancelarCola$ = this.cancelarSource.asObservable();

  solicitarCancelacion(cOID: string) {
    this.cancelarSource.next(cOID);
  }
  private pollingSubscription: Subscription;

  // Add getters and setters
  getIdCartera(): number {
    return this.idcartera;
  }

  setIdCartera(id: number) {
    this.idcartera = id;
    // Optionally persist to localStorage
    localStorage.setItem('idcartera', id.toString());
  }

  getIdCarteraGestor(): number {
    return this.idcarteragestor;
  }

  setIdCarteraGestor(id: number) {
    this.idcarteragestor = id;
    // Optionally persist to localStorage
    localStorage.setItem('idcarteragestor', id.toString());
  }

  ngOnDestroy() {
    this.stopPolling();
  }

  constructor(private ngZone: NgZone, private http: HttpClient, private _cookieService: CookieService, private _sseservice: SseService) {
    console.log('ColaOrdenesService inicializado');
 // Load saved IDs from localStorage
    const savedIdCartera = localStorage.getItem('idcartera');
    const savedIdCarteraGestor = localStorage.getItem('idcarteragestor');
    
    if (savedIdCartera) {
      this.idcartera = parseInt(savedIdCartera);
    }
    if (savedIdCarteraGestor) {
      this.idcarteragestor = parseInt(savedIdCarteraGestor);
    }
    // Inicializar los BehaviorSubjects con datos del localStosrage si existen
    this.loadFromLocalStorage();

    // Escuchar cambios en localSstorage
    window.addEventListener('storage', (event) => {
      // Usar NgZone para asegurar que la detección de cambios de Angular se active
      this.ngZone.run(() => {
        if (event.key === 'colaOrdenes') {
          this.colaOrdenesSource.next(JSON.parse(event.newValue || '[]'));
        } else if (event.key === 'colaOrdenesGestor') {
          this.colaOrdenesSourceGestor.next(JSON.parse(event.newValue || '[]'));
        } else if (event.key === 'operaciones') {
          this.operacionesSource.next(JSON.parse(event.newValue || '[]'));
        } else if (event.key === 'operacionesGestor') {
          this.operacionesSourceGestor.next(JSON.parse(event.newValue || '[]'));
        }
      });
    });
  }

  updateColaOrdenes(colaOrdenes: any[]) {
    this.colaOrdenesSource.next(colaOrdenes);
    localStorage.setItem('colaOrdenes', JSON.stringify(colaOrdenes));
  }

  updateColaOrdenesGestor(colaOrdenes: any[]) {
    this.colaOrdenesSourceGestor.next(colaOrdenes);
    localStorage.setItem('colaOrdenesGestor', JSON.stringify(colaOrdenes));
  }

  updateOperaciones(operaciones: operationinterface[]) {
    //this.operacionesSource.next(operaciones);
    //const operacionesExistentes: operationinterface[] = JSON.parse(localStorage.getItem('operaciones') || '[]');
    //const operacionesCombinadas = [...operacionesExistentes, ...operaciones];
    
    this.operacionesSource.next(operaciones);
    localStorage.setItem('operaciones', JSON.stringify(operaciones));
    // Save to database
    if (operaciones.length > 0) {
      const idcartera = operaciones[0].idcartera;
      this.saveOperacionesToDB(operaciones, idcartera).subscribe({
        next: (response) => {
          console.log('Operaciones guardadas en BD:', response);
        },
        error: (error) => {
          console.error('Error guardando operaciones en BD:', error);
        }
      });
    }
//    localStorage.setItem('operaciones', JSON.stringify(operaciones));
  }

  updateOperacionesGestor(nuevasOperaciones: operationinterface[]) {
    //const operacionesExistentes: operationinterface[] = JSON.parse(localStorage.getItem('operacionesGestor') || '[]');
  //  const operacionesCombinadas = [...operacionesExistentes, ...nuevasOperaciones];
    this.operacionesSourceGestor.next(nuevasOperaciones);
    localStorage.setItem('operacionesGestor', JSON.stringify(nuevasOperaciones));
    // Save to database
    if (nuevasOperaciones.length > 0) {
      const idcartera = nuevasOperaciones[0].idcartera;
      this.saveOperacionesToDB(nuevasOperaciones, idcartera).subscribe({
        next: (response) => {
          console.log('Operaciones guardadas en BD:', response);
        },
        error: (error) => {
          console.error('Error guardando operaciones en BD:', error);
        }
      });
    }
  }
private fetchOperacionesFromDB(idcartera: number) {
    // Sin cartera no hay operaciones: no pegarle al backend cada 3s con operaciones/0.
    if (!(idcartera > 0)) return of([]);
    return this._sseservice.apiGetWithAuth(`operaciones/${idcartera}`, this._cookieService.get('auth_token'));
  }

  // Add method to stop polling
  private stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  private loadFromLocalStorage() {
    const colaOrdenes = JSON.parse(localStorage.getItem('colaOrdenes') || '[]');
    const colaOrdenesGestor = JSON.parse(localStorage.getItem('colaOrdenesGestor') || '[]');
    this.colaOrdenesSource.next(colaOrdenes);
    this.colaOrdenesSourceGestor.next(colaOrdenesGestor);

    const currentOps = JSON.parse(localStorage.getItem('operaciones') || '[]');
    //if (currentOps.length > 0) {
      this.stopPolling();

      // Start new polling
      this.pollingSubscription = interval(3000)
        .pipe(
          switchMap(() => {
            const idCarteraStr = localStorage.getItem('idcartera');
            const idCartera = idCarteraStr ? parseInt(idCarteraStr, 10) : 0;
            return this.fetchOperacionesFromDB(idCartera);
          })
        )
        .subscribe({
          next: (response: any) => {
            //console.log('Operaciones actualizadas desde DB:', response);
            this.operacionesSource.next(response);
          },
          error: (error) => {
            console.error('Error fetching operations:', error);
           // const operaciones = JSON.parse(localStorage.getItem('operaciones') || '[]');
           // this.operacionesSource.next(operaciones);
          }
        });

          const operacionesGestor = JSON.parse(localStorage.getItem('operacionesGestor') || '[]');
          this.operacionesSourceGestor.next(operacionesGestor);
   // }
  }
  clearLocalStorageForCartera(idcartera: number) {
    // Limpiar colaOrdenes
    let colaOrdenes = JSON.parse(localStorage.getItem('colaOrdenes') || '[]');
    colaOrdenes = colaOrdenes.filter((orden: any) => orden.idcartera !== idcartera);
    localStorage.setItem('colaOrdenes', JSON.stringify(colaOrdenes));
    this.colaOrdenesSource.next(colaOrdenes);

    // Limpiar colaOrdenesGestor
    let colaOrdenesGestor = JSON.parse(localStorage.getItem('colaOrdenesGestor') || '[]');
    colaOrdenesGestor = colaOrdenesGestor.filter((orden: any) => orden.idcartera !== idcartera);
    localStorage.setItem('colaOrdenesGestor', JSON.stringify(colaOrdenesGestor));
    this.colaOrdenesSourceGestor.next(colaOrdenesGestor);

    // Limpiar operaciones
    let operaciones = JSON.parse(localStorage.getItem('operaciones') || '[]');
    operaciones = operaciones.filter((op: operationinterface) => op.idcartera !== idcartera);
    localStorage.setItem('operaciones', JSON.stringify(operaciones));
    this.operacionesSource.next(operaciones);

    // Limpiar operacionesGestor
    let operacionesGestor = JSON.parse(localStorage.getItem('operacionesGestor') || '[]');
    operacionesGestor = operacionesGestor.filter((op: operationinterface) => op.idcartera !== idcartera);
    localStorage.setItem('operacionesGestor', JSON.stringify(operacionesGestor));
    this.operacionesSourceGestor.next(operacionesGestor);
    console.log(`Datos de localStorage limpiados para idcartera: ${idcartera}`);
  }

  saveOperacionesToDB(operaciones: operationinterface[], idcartera: number) {
    const payload = {
      operaciones: operaciones,
      idcartera: idcartera
    };
    
    return this._sseservice.apiPostNew(`operacionesSave`, payload, this._cookieService.get('auth_token'));
  }

}


